import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ProductService } from '../../services/product/product.service';
import { Product } from '../../models/product';

import { RouterModule, RouterLink } from '@angular/router';
import {ProductNamePipe} from "../../pipes/product-name.pipe";
import {AppLogger, AppLoggerService} from "../../core/logging";

@Component({
  selector: 'app-expiring-products-teaser',
  standalone: true,
  imports: [RouterModule, RouterLink, ProductNamePipe],
  templateUrl: './expiring-products-teaser.component.html',
  styleUrls: ['./expiring-products-teaser.component.scss']
})
export class ExpiringProductsTeaserComponent implements OnInit, OnChanges {

  private readonly log: AppLogger;

  @Input() from?: string | Date;
  @Input() to?: string | Date;
  @Input() limit?: number;
  @Input() householdId?: number;
  @Input() reloadToken?: number;

  products: Product[] = [];
  loading = false;

  constructor(private productService: ProductService, private appLogger: AppLoggerService) {
    this.log = this.appLogger.createForClass(ExpiringProductsTeaserComponent);
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.from || changes.to || changes.limit || changes.householdId || changes.reloadToken) {
      this.load();
    }
  }

  private load(): void {

    this.log.debug('Loading expiring products teaser with params', {
      householdId: this.householdId,
      from: this.from,
      to: this.to,
      limit: this.limit
    });

    const hid = this.householdId;

    // When context switches, householdId may briefly be undefined/null.
    // Avoid calling the API with a bogus id and reflect the unloaded state.
    if (hid == null) {
      this.products = [];
      this.loading = false;
      return;
    }

    this.loading = true;
    this.productService.getExpiringProducts(hid, this.from, this.to, this.limit).subscribe({
      next: (prods) => {
        // sort by next_expiration ascending
        this.products = (prods ?? []).slice().sort((a, b) => {
          const ad = a.stock?.next_expiration ?? '';
          const bd = b.stock?.next_expiration ?? '';
          if (!ad && !bd) return 0;
          if (!ad) return 1;
          if (!bd) return -1;
          return ad.localeCompare(bd);
        });
        if (this.limit && this.products.length > this.limit) {
          this.products = this.products.slice(0, this.limit);
        }
      },
      error: () => {
        this.products = [];
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  trackById(index: number, item: Product) {
    return item.id ?? index;
  }

  formatDate(dateStr?: string) {
    if (!dateStr) return '';
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString();
    } catch (e) {
      return dateStr;
    }
  }

}
